import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  CardTitle,
  Form,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import FileDownload from "js-file-download"
import Switch from "react-switch"
import { Slide, toast, ToastContainer } from "react-toastify"
import Select from "react-select"

const DataTableEtudiantOrientation = props => {
  const [disbutReg, setDisbutReg] = useState(true)
  const [loadingBar, setLoadingBar] = useState(false)
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  // Data Table
  const [orders, setOrders] = useState([])
  const [edit, setEdit] = useState(0)
  const [add, setAdd] = useState(0)
  const [delet, setDelet] = useState(0)
  const [excel, setExcel] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [niveau, setNiveau] = useState([
    { value: 2, label: "2 ème Année" },
    { value: 3, label: "3 ème Année" },
  ])
  const [selectNiveau, setSelectNiveau] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [modalGeneAuto, setModalGeneAuto] = useState(false)
  const [modalGeneAutoSpec, setModalGeneAutoSpec] = useState(false)
  const [modalReinitialisation, setModalReinitialisation] = useState(false)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const [status, setStatus] = useState([
    { value: 1, label: "En attente" },
    { value: 2, label: "Accepté" },
    { value: 3, label: "Refusée" },
    { value: 4, label: "Non traité" },
  ])
  const [selectStatus, setSelectStatus] = useState("")
  const [modalDetail, setModalDetail] = useState(false)
  const [title, setTitle] = useState("")
  const [msg, setMsg] = useState("")
  const [modalAfficher, setModalAfficher] = useState(false)
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "cin",
      text: props.t("CIN"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nom_etudiant",
      text: props.t("Etudiant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite_source",
      text: props.t("Spécialité d'origine"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite_destination",
      text: props.t("Spécialité d'orientation"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "statut",
      text: props.t("Statut actuel"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "score_final",
      text: props.t("Score"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "statut_modifier",
      text: props.t("Statut"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "#64d4ed", cursor: "pointer" }}
            onClick={() => toggle(row.id)}
            className="fas fa-check"
          ></i>
        </div>
      ),
    },
  ]
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const { SearchBar } = Search
  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    // const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    //
    // const typeArticleSubMenu = userAuth.find(user =>
    //   user.sous_menu.some(
    //     subMenu => subMenu.sous_menu === "Matière Orientation"
    //   )
    // )
    //
    // setAdd(typeArticleSubMenu.sous_menu[2].add)
    // setEdit(typeArticleSubMenu.sous_menu[2].edit)
    // setDelet(typeArticleSubMenu.sous_menu[2].delete)
    // setExcel(typeArticleSubMenu.sous_menu[2].exel)
    const loadData = async () => {
      try {
        const cloture_annee = JSON.parse(localStorage.getItem("cloture"))
        setCloture(cloture_annee)

        const userAuth = JSON.parse(localStorage.getItem("UserMenu")) || []

        const typeArticleSubMenu = userAuth.find(
          user =>
            Array.isArray(user.sous_menu) &&
            user.sous_menu.some(
              subMenu => subMenu.sous_menu === "Etudiants Orientation"
            )
        )

        if (typeArticleSubMenu) {
          const menu = typeArticleSubMenu.sous_menu.find(
            subMenu => subMenu.sous_menu === "Etudiants Orientation"
          )

          if (menu) {
            setAdd(menu.add)
            setEdit(menu.edit)
            setDelet(menu.delete)
            setExcel(menu.exel)
          }
        } else {
          console.warn("Le sous-menu 'Etudiants Orientation' est introuvable.")
        }
      } catch (error) {
        console.error(error)
      }
    }

    loadData()

    const res = await API.post("candidature_orientation/list", {
      annee_id,
    }).then(res => {
      setOrders(res.data.Candidatures)
    })
    setLoading(true)
  }, [])
  const getSpec = async event => {
    setSelectNiveau(event)
    setSelectSpecialite("")

    const res = await API.post(
      "candidature_orientation/select_destination_by_niveau",
      {
        niveau_id: event.value,
        annee_id,
      }
    ).then(res => {
      setSpecialite(res.data.Specialites)
    })
  }
  const search = async () => {
    const specialite_destination_id = selectSpecialite?.value ?? 0
    const niveau_id = selectNiveau?.value ?? 0
    const statut_id = selectStatus?.value ?? 0
    setOrders([])
    const res = await API.post("candidature_orientation/search", {
      specialite_destination_id,
      niveau_id,
      statut_id,
      annee_id,
    }).then(res => {
      setOrders(res.data.Candidatures)
    })
  }
  const searchAll = async () => {
    setSelectSpecialite("")
    const res = await API.post("candidature_orientation/list", {
      annee_id,
    }).then(res => {
      setOrders(res.data.Candidatures)
    })
  }
  const uploadExcelLicence = async () => {
    const specialite_destination_id = selectSpecialite?.value ?? 0
    const niveau_id = selectNiveau?.value ?? 0
    const statut_id = selectStatus?.value ?? 0
    const res = await API.post(
      "candidature_orientation/export",
      {
        specialite_destination_id,
        niveau_id,
        statut_id,
        annee_id,
      },
      { responseType: "blob" }
    ).then(res => {
      FileDownload(res.data, "liste des candidats.xlsx")
    })
  }
  const toggleValider = async () => {
    if (selectStatus === "") {
      setDisbutReg(true)
      await toggleDetail("Champs obligatoire.", "⛔ Status est obligatoire.")
      return
    }
    const res = await API.post("candidature_orientation/update_statut", {
      id: id,
      statut_id:selectStatus.value,
      user_id
    }).then(res => {
      setModal(false)
       API.post("candidature_orientation/list", {
        annee_id,
      }).then(resList => {
        setOrders(resList.data.Candidatures)
      })
      setLoading(true)
    })
  }
  const toggleDetail = async (title, msg) => {
    setModalDetail(!modalDetail)
    if (modalDetail !== true) {
      setTitle(title)
      setMsg(msg)
    }
  }
  const toggleGeneAuto = row => {
    setModalGeneAuto(!modalGeneAuto)
  }
  const toggleGeneAutoSpec = row => {
    setModalGeneAutoSpec(!modalGeneAutoSpec)
  }
  const generationAuto = async () => {
    setLoadingBar(true)
    try {
      const res = await API.post(
        "candidature_orientation/affectation_orientations",
        {
          annee_id,
          user_id,
        }
      )
      if (res.data.errNum === 200 || res.data.errNum === "200") {
        const res = await API.post("candidature_orientation/list", {
          annee_id,
        }).then(res => {
          setOrders(res.data.Candidatures)
          setModalGeneAuto(false)
          toast.success("✔️ " + res.data.msg, { containerId: "A" })
        })

      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  const generationAutoSpec = async () => {
    const specialite_source_id = selectSpecialite?.specialite_source_id ?? 0
    const niveau_id = selectNiveau?.value ?? 0
    if (specialite_source_id == 0) {
      setDisbutReg(true)
      await toggleDetail(
        "Champs obligatoire.",
        "⛔ Spécialité est obligatoire."
      )
      return
    }
    if (niveau_id == 0) {
      setDisbutReg(true)
      await toggleDetail("Champs obligatoire.", "⛔ Niveau est obligatoire.")
      return
    }
    setLoadingBar(true)
    try {
      const res = await API.post(
        "candidature_orientation/affectation_orientation",
        {
          annee_id,
          user_id,
          specialite_source_id,
          niveau_id
        }
      )
      if (res.data.errNum === 200 || res.data.errNum === "200") {
        const res = await API.post("candidature_orientation/list", {
          annee_id,
        }).then(res => {
          setOrders(res.data.Candidatures)
          setModalGeneAutoSpec(false)
          toast.success("✔️ " + res.data.msg, { containerId: "A" })
        })
      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  const toggleReinitialisation = row => {
    setModalReinitialisation(!modalReinitialisation)
  }
  const toggleAfficher = row => {
    setModalAfficher(!modalAfficher)
  }
  const ReinitialisationCandidature = async () => {
    setLoadingBar(true)
    try {
      const res = await API.post("candidature_orientation/reinitialisation", {
        annee_id,
        user_id,
      })
      if (res.data.errNum === 200 || res.data.errNum === "200") {
        API.post("candidature_orientation/list", { annee_id }).then(resCa => {
          setOrders(resCa.data.Candidatures)
          setModalReinitialisation(false)
          toast.success("✔️ " + res.data.msg, { containerId: "A" })
        })
      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  const toggleAfficherAnnuler = async () => {
    try {
      const res = await API.post(
        "candidature_orientation/updateAffichageByAnnee",
        {
          annee_id,
          user_id,
          afficher:0,
        }
      )
      if (res.data.errNum === 200 || res.data.errNum === "200") {
          setModalAfficher(false)
          toast.success("✔️ " + res.data.msg, { containerId: "A" })
      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  const toggleAfficherA = async () => {
    try {
      const res = await API.post(
        "candidature_orientation/updateAffichageByAnnee",
        {
          annee_id,
          user_id,
          afficher: 1,
        }
      )
      if (res.data.errNum === 200 || res.data.errNum === "200") {
        setModalAfficher(false)
        toast.success("✔️ " + res.data.msg, { containerId: "A" })
      }
    } catch (error) {
      toast.error("Erreur lors de la génération !")
    } finally {
      setLoadingBar(false)
    }
  }
  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <CardTitle style={{ color: "#556ee6" }} className="h4">
                      Critéres de Recherches
                    </CardTitle>
                    <Form className="mt-4">
                      <Row>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {props.t("Niveau")}
                            </Label>
                            <Select
                              options={niveau}
                              isSearchable={true}
                              onChange={e => getSpec(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Spécialité
                            </Label>
                            <Select
                              options={specialite}
                              isSearchable={true}
                              value={selectSpecialite}
                              onChange={e => setSelectSpecialite(e)}
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Status
                            </Label>
                            <Select
                              options={status}
                              isSearchable={true}
                              value={selectStatus}
                              onChange={e => setSelectStatus(e)}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        {loadingBar && (
                          <div className="mt-3">
                            <div className="progress">
                              <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                style={{ width: "100%" }}
                              ></div>
                            </div>
                            <p className="text-center mt-2">
                              Traitement en cours...
                            </p>
                          </div>
                        )}
                      </Row>
                    </Form>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Col lg="12">
                        <div className="text-center mt-4">
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#761C19",
                              borderColor: "#761C19",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={search}
                          >
                            Rechercher
                          </button>
                          <button
                            type="button"
                            style={{
                              backgroundColor: "#761C19",
                              borderColor: "#761C19",
                            }}
                            className="btn btn-success mb-2 me-2"
                            onClick={searchAll}
                          >
                            Afficher tout
                          </button>
                          {excel === 1 ? (
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#8ba503",
                                borderColor: "#8ba503",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={uploadExcelLicence}
                            >
                              <i className="fas fa-file-excel font-size-18 align-middle me-2"></i>
                              {"Exportation tous les candidatures"}
                            </button>
                          ) : null}
                          {add === 1 ? (
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#CA3C66",
                                borderColor: "#CA3C66",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={toggleGeneAuto}
                            >
                              {"Génération automatique "}
                              <br />
                              {"d'orientation des étudiants "}
                            </button>
                          ) : null}
                          {add === 1 ? (
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#a23cca",
                                borderColor: "#A23CCAFF",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={toggleGeneAutoSpec}
                            >
                              {"Génération automatique d'orientation "}
                              <br />
                              {" des étudiants par spécialité"}
                            </button>
                          ) : null}
                          {add === 1 ? (
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#CE6A6B",
                                borderColor: "#CE6A6B",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={toggleReinitialisation}
                            >
                              {"Réinitialiser les statuts des candidatures"}
                            </button>
                          ) : null}
                          {add === 1 ? (
                            <button
                              type="button"
                              style={{
                                backgroundColor: "#64d4ed",
                                borderColor: "#64d4ed",
                              }}
                              className="btn btn-success mb-2 me-2"
                              onClick={toggleAfficher}
                            >
                              {
                                "Afficher la résultat pour tous les candidatures"
                              }
                            </button>
                          ) : null}
                        </div>
                      </Col>
                    </div>
                    <div>
                      <div className="mb-3 row" style={{ display: "flex" }}>
                        <div className="col-md-6 mb-3 row">
                          <div className="col-md-8 search-box-etd">
                            <div
                              className="search-box me-2 mb-2 d-inline-block"
                              style={{ width: "100%" }}
                            >
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement")} ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modalGeneAuto} toggle={toggleGeneAuto} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleGeneAuto}
          tag="h4"
        >
          {"Génération automatique d'orientation des étudiants"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-vous sûr(e) de vouloir générer automatique d'orientation des étudiants"
                }
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={generationAuto}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleGeneAuto}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalGeneAutoSpec}
        toggle={toggleGeneAutoSpec}
        centered={true}
      >
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleGeneAutoSpec}
          tag="h4"
        >
          {"Génération automatique d'orientation des étudiants par spécialité"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {
                  "Êtes-vous sûr(e) de vouloir générer automatique d'orientation des étudiants par spécialité"
                }
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={generationAutoSpec}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleGeneAuto}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Changer la statut d'étudiant orientation")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <Row>
              <Col lg="12">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Status</Label>
                  <Select
                    options={status}
                    isSearchable={true}
                    value={selectStatus}
                    onChange={e => setSelectStatus(e)}
                  />
                </div>
              </Col>
            </Row>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleValider}
                  disabled={!disbutReg}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalDetail} toggle={toggleDetail} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          toggle={toggleDetail}
        >
          {title}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{msg}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
                marginTop: "17px",
              }}
            >
              <div>
                <Button
                  onClick={toggleDetail}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Fermer
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalReinitialisation}
        toggle={toggleReinitialisation}
        centered={true}
      >
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleReinitialisation}
          tag="h4"
        >
          {"Réinitialisation les statuts du candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Êtes-vous sûr(e) de vouloir réinitialiser les statuts du
                candidatures ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={ReinitialisationCandidature}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  OUI
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleReinitialisation}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  NON
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalAfficher} toggle={toggleAfficher} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggleAfficher}
          tag="h4"
        >
          {"Afficher le résultat du candidatures"}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                Êtes-vous sûr(e) de vouloir afficher le résultat du candidatures
                ?
              </p>
            </div>

            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleAfficherA}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Afficher
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleAfficherAnnuler}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {"Annuler l'affichage"}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableEtudiantOrientation))
DataTableEtudiantOrientation.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
